// extracted by mini-css-extract-plugin
export default {"depoimentos-container":"Depoimentos_depoimentos-container__oF-b6","depoimentos-section":"Depoimentos_depoimentos-section__I2Swl"};